import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/details-v4/WorkspaceDetailsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/tracking/WorkspaceDiscoveryTracking.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/store/store.ts");
